import { render, staticRenderFns } from "./RectangleIcon.vue?vue&type=template&id=39a62f81&"
import script from "./RectangleIcon.vue?vue&type=script&lang=js&"
export * from "./RectangleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports